var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player-wrapper"},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-theme-city vjs-fluid vjs-16-9",attrs:{"controls":"","playsinline":"","preload":"metadata"}})])}
var staticRenderFns = []

export { render, staticRenderFns }